<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
    height="100%"
  >
    <validation-observer ref="memoDepositForm">

      <!-- 1. Description -->
      <dashboard-alert
        v-if="headDescription"
        variant="info"
        bg-variant="light"
      >
        <div v-html="headDescription" />
      </dashboard-alert>

      <dashboard-alert
        v-if="footerDescription"
        class="mt-2"
        variant="info"
        bg-variant="light"
      >
        <div v-html="footerDescription" />
      </dashboard-alert>

      <b-card class="mt-2 ">
        <b-row>
          <b-col
            sm="12"
            md="4"
          >
            <!-- Currency Select -->
            <b-form-group
              label-for="currency-select"
              :label="$t('fiat_wallet_deposit_currency')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('fiat_wallet_deposit_currency')"
                vid="Currency"
                rules="required"
              >
                <v-select
                  id="currency-select"
                  v-model="currency"
                  :options="currencyList"
                  :placeholder="$t('fiat_wallet_deposit_currency')"
                  label="name"
                  track-by="id"
                  @input="val => { currency = val; getBankList(val.id) }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </b-col>
          <b-col
            sm="12"
            md="4"
          >
            <!-- Bank Select -->
            <b-form-group
              label-for="bank-select"
              :label="$t('bank')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('bank')"
                vid="Bank"
                rules="required"
              >
                <v-select
                  id="bank-select"
                  v-model="bankAccount"
                  :options="bankList"
                  :placeholder="$t('bank')"
                  label="bank_name"
                  track-by="id"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            v-if="bankAccount && bankAccount.memo"
            sm="12"
            md="4"
          >
            <b-form-group
              label-for="memo"
              :label="$t('your_deposit_memo')"
            >
              <b-input-group>
                <b-form-input
                  ref="memoInput"
                  :value="bankAccount.memo"
                  readonly
                  class=""
                />
                <b-input-group-append>
                  <b-button
                    ref="copyBtn"
                    v-b-tooltip.hover.focus="copyTooltip"
                    :title="$t('copy')"
                    style="height: 38px;"
                    variant="primary"
                    @click="copyMemo"
                  >
                    <BIconClipboard
                      style="width: 24px;"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col class="d-flex flex-column align-items-center">
            <HistoryCard
              :items="[bankAccount]"
              :fields="bankAccountFields"
            >
              <template #item(min_deposit_amount)="{ item }">
                <span dir="rtl">{{ helpers.numberWithCommas(helpers.toFixed(item.min_deposit_amount, item.currency.currency_decimal)) +' '+item.currency.name }}</span>
              </template>
              <template #item(max_deposit_amount)="{ item }">
                <span dir="rtl">{{ helpers.numberWithCommas(helpers.toFixed(item.max_deposit_amount, item.currency.currency_decimal)) +' '+item.currency.name }}</span>
              </template>
              <template #item(fee)="{ item }">
                <span dir="rtl">{{ helpers.numberWithCommas(helpers.toFixed(item.fee, item.currency.currency_decimal)) +' '+item.currency.name }}</span>
              </template>
            </HistoryCard>
          </b-col>
        </b-row>
      </b-card>
      <!-- 4. Deposit History -->
      <b-card class="deposit-history ">
        <h3 class="mb-0">
          {{ $t('deposit_history') }}
        </h3>
        <br>
        <history-card
          :items="depositHistory"
          :fields="historyFields"
          @page-change="$emit('history-page-change', $event)"
        >
          <template #item(amount)="data">
            <span>{{ helpers.numberWithCommas(helpers.toFixed(data.item.amount, 2)) }}</span>
          </template>
          <template #item(automation.status)="data">
            <span :class="data.item.automation.status === 'pending' ? 'text-warning' : data.item.automation.status === 'successful' ? 'text-success' : data.item.automation.status === 'rejected' ? 'text-danger' : 'text-info'">
              {{ data.item.automation.status }}
            </span>
          </template>
        </history-card>
      </b-card>
    </validation-observer>
  </b-overlay>
</template>

<script>
import fiatMemoDeposit from '@/modules/crypto/views/logic/customer-wallets/fiat/fiatMemoDeposit'
import DashboardAlert from '@/views/theme2/dashboard/dashboardAlert.vue'
import HistoryCard from '../../components/historyCard.vue'

export default {
  components: {
    DashboardAlert,
    HistoryCard,
  },
  mixins: [fiatMemoDeposit],
  computed: {
    bankAccountFields() {
      return [
        { key: 'account_number', label: this.$t('account_number') },
        { key: 'iban', label: this.$t('iban') },
        { key: 'card_name', label: this.$t('account_owner') },
        { key: 'bank_name', label: this.$t('bank') },
        { key: 'min_deposit_amount', label: this.$t('min_deposit_amount') },
        { key: 'max_deposit_amount', label: this.$t('max_deposit_amount') },
        { key: 'fee', label: this.$t('fee') },
      ]
    },
  },
}
</script>

<style scoped>
.fiat-memo-deposit {
  box-shadow: none;
  margin: 0 auto;
}
.memo-value {
  font-size: 1.2em;
  color: #2d8cf0;
  font-weight: bold;
}
.bg-dark-blue {
  background-color: rgb(2, 58, 110);
}
</style>
